<template>
  <div>
    <p class="text-sm mb-2 text-center text-staticsecondary-600 dark:text-staticdarkblue-200">{{$t('noauth.first_access_label')}}</p>
    <el-form
      @submit.prevent.native="doLogin('firstLoginForm')"
      class="px-4 sm:px-0"
      :model="firstLoginForm"
      :rules="firstLoginFormRules"
      ref="firstLoginForm"
      novalidate
    >
      <div>
        <el-form-item  prop="oldPassword">
          <el-input
            ref="firstLoginPasswordInput"
            :placeholder="$t('configurations.old_password')"
            type="password"
            class="mb-2 custom__icons static-css"
            show-password
            v-model="firstLoginForm.oldPassword"
            maxlength='50'
          >
            <i slot="prefix" class="el-input__icon">
              <BaseIcon size="sm" name="lock" />
            </i>
            <template v-if="firstLoginForm.oldPassword" slot="suffix">
              <base-clear-input-button
                :aria-label="$t('aria.clean.old_password')"
                @clear="firstLoginForm.oldPassword = ''"
              />
            </template>
          </el-input>
        </el-form-item>
      </div>
      <base-password-form-item v-model="firstLoginForm.newPassword" name="newPassword" :placeholder="$t('noauth.new_password')" />
      <base-password-form-item v-model="firstLoginForm.repeatPassword" :password="firstLoginForm.newPassword" name="repeatPassword" :placeholder="$t('noauth.confirm_password')" repeat />
      <base-button
        class="w-full mt-4"
        mode="staticprimary"
        text="Acceder"
        type="submit"
        :loading = "loader"
      />
    </el-form>
  </div>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  name: 'first-login-form',
  data: function () {
    return {
      loader: false,
      firstLoginForm: {
        oldPassword: '',
        newPassword: '',
        repeatPassword: '',
      },
      firstLoginFormRules: {
        oldPassword: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
      }
    }
  },
  mounted: async function () {
    this.$nextTick(() => {
      // Timeout para esperar a que se rendericen los iconos
      setTimeout(() => {
        this.fixAccesibilityElInputPassword(this.$refs.firstLoginPasswordInput, this.$i18n.t('aria.elementui.input.password'))
      }, 1000)
    })
  },
  methods: {
    doLogin: async function (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.loader = true
            const payload = {
              oldPassword: this.firstLoginForm.oldPassword,
              password: this.firstLoginForm.newPassword,
            }
            await this.$store.dispatch('auth/firstLoginPassword', payload)
            await this.$store.dispatch('app/getAnnouncementsList')
          } catch (error) {
            if (error !== undefined && error.blnError) {
              if (error.stepCode === 2) {
                this.$emit('cleanToggleForms')
                this.$emit('activeLoginOTPConfig')
              } else if (error.stepCode === 3) {
                this.$emit('cleanToggleForms')
                this.$emit('activeLoginOTP')
              } else {
                this.doFeedback(i18n.t('feedback.error.formated_api_response_error', error))
              }
            } else {
              this.doFeedback()
            }
          } finally {
            this.loader = false
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
      })
    },
  }
}
</script>

<style scoped>
.dark .el-input .el-input__inner {
  border-color: var(--staticdarkblue-600) !important;
  background-color: var(--staticdarkblue-DEFAULT) !important;
  color: var(--staticdarkblue-300) !important;
}
</style>
